export default "__VITE_ASSET__DmU5Ism7__"